import React, { useRef, useEffect, useState } from 'react';
import { Eraser } from 'lucide-react';
import { useT } from '../context/LanguageContext';

// Canvas-handtekening. Geeft via onChange een PNG data-URL terug (of '' bij leeg).
export default function SignaturePad({ onChange, height = 160 }) {
  const { t } = useT();
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = c.getBoundingClientRect();
    c.width = rect.width * ratio;
    c.height = height * ratio;
    const ctx = c.getContext('2d');
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.strokeStyle = '#0f172a';
  }, [height]);

  const pos = (e) => {
    const c = canvasRef.current; const rect = c.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - rect.left, y: p.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext('2d'); const { x, y } = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext('2d'); const { x, y } = pos(e); ctx.lineTo(x, y); ctx.stroke(); if (empty) setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; if (!empty && onChange) onChange(canvasRef.current.toDataURL('image/png')); };
  const clear = () => { const c = canvasRef.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); setEmpty(true); onChange && onChange(''); };

  return (
    <div>
      <div style={{ position: 'relative', border: '1.5px dashed #94a3b8', borderRadius: 10, background: '#fff', overflow: 'hidden' }}>
        <canvas ref={canvasRef} data-testid="signature-canvas" style={{ width: '100%', height, touchAction: 'none', display: 'block', cursor: 'crosshair' }}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
        {empty && <span style={{ position: 'absolute', top: '50%', left: 0, right: 0, transform: 'translateY(-50%)', textAlign: 'center', color: '#cbd5e1', fontSize: 14, pointerEvents: 'none' }}>{t('Teken hier uw handtekening')}</span>}
      </div>
      <button type="button" onClick={clear} data-testid="signature-clear" style={{ marginTop: 6, display: 'inline-flex', alignItems: 'center', gap: 5, border: 'none', background: 'none', color: '#64748b', fontSize: 12.5, cursor: 'pointer' }}>
        <Eraser size={13} /> {t('Wissen')}
      </button>
    </div>
  );
}
